import { memo, ReactNode } from 'react'
import { Box, IconButton, Stack, Typography } from '@mui/material'
import ArrowBackIcon from '../../assets/icons/ArrowBackIcon'
import { NonInteractiveTooltip } from '../custom'

type Props = {
    title: string
    /** Leading icon for top-level screens; sub-screens pass `onBack` instead. */
    icon?: ReactNode
    onBack?: () => void
    actions?: ReactNode
}

/** Slot width shared by the icon and the back button so titles line up across screens. */
const LEADING_SLOT = 36

/** Same 40px header row as the other sidebar tabs (icon or back, title, optional actions). */
const SupportHeader = ({ title, icon, onBack, actions }: Props) => (
    <Stack
        direction="row"
        alignItems="center"
        sx={{ flexShrink: 0, minHeight: 40, px: 1, borderBottom: 1, borderColor: 'divider' }}
    >
        <Box
            sx={{
                width: LEADING_SLOT,
                display: 'flex',
                alignItems: 'center',
                justifyContent: onBack ? 'flex-start' : 'center',
                color: 'text.secondary',
                flexShrink: 0
            }}
        >
            {onBack ? (
                <NonInteractiveTooltip title="Back" arrow placement="top">
                    <IconButton size="small" onClick={onBack} aria-label="Back" sx={{ color: 'text.secondary', ml: -0.5 }}>
                        <ArrowBackIcon sx={{ fontSize: 18 }} />
                    </IconButton>
                </NonInteractiveTooltip>
            ) : (
                icon
            )}
        </Box>
        <Typography variant="body1" fontWeight={500} noWrap sx={{ flex: 1, minWidth: 0 }}>
            {title}
        </Typography>
        {actions}
    </Stack>
)

export default memo(SupportHeader)
